import * as L from 'leaflet';

export const pinIcon = new L.Icon({
  iconUrl: 'assets/images/pins/pin.svg',
  iconSize: [20, 50]
});

export const consulateIcon = new L.Icon({
  iconUrl: 'assets/images/pins/flag.svg',
  iconSize: [20, 50]
});

export const universityIcon = new L.Icon({
  iconUrl: 'assets/images/pins/university.svg',
  iconSize: [20, 25]
});

export const currentLocationIcon = new L.Icon({
  iconUrl: 'assets/images/pins/location.svg',
  iconSize: [40, 40]
});

export const trashIcon = new L.Icon({
  iconUrl: 'assets/images/pins/trashContainer.svg',
  iconSize: [30, 60]
});

export const sensorIcon = new L.Icon({
  iconUrl: 'assets/images/pins/sensorIcon.svg',
  iconSize: [30, 50]
});

export const gatewayIcon = new L.Icon({
  iconUrl: 'assets/images/pins/gatewayIcon.svg',
  iconSize: [30, 50]
});

export const pluviometerIcon = new L.Icon({
  iconUrl: 'assets/images/pins/pluviometerIcon.svg',
  iconSize: [50, 80]
});

export const bikeIcon = new L.Icon({
  iconUrl: 'assets/images/pins/bikeway.svg',
  iconSize: [30, 60]
});

export const levelSensorIcon = new L.Icon({
  iconUrl: 'assets/images/pins/levelSensor.svg',
  iconSize: [50, 80]
});

export const levelSensorBlueIcon = new L.Icon({
  iconUrl: 'assets/images/pins/levelSensorBlue.svg',
  iconSize: [50, 80]
});

export const co2SensorIcon = new L.Icon({
  iconUrl: 'assets/images/pins/co2Sensor.svg',
  iconSize: [50, 80]
});

export const soundSensorIcon = new L.Icon({
  iconUrl: 'assets/images/pins/soundSensor.svg',
  iconSize: [50, 80]
});

export const safeTaxiIcon = new L.Icon({
  iconUrl: 'assets/images/pins/safeTaxiIcon.svg',
  iconSize: [60, 60]
});

export const restrictionIcon = new L.Icon({
  iconUrl: 'assets/images/pins/restriction.svg',
  iconSize: [30, 60]
});

export const hospitalIcon = new L.Icon({
  iconUrl: 'assets/images/pins/hospital.svg',
  iconSize: [30, 50]
});

export const policeIcon = new L.Icon({
  iconUrl: 'assets/images/pins/police.svg',
  iconSize: [30, 60]
});

export const wifiIcon = new L.Icon({
  iconUrl: 'assets/images/pins/wifi.svg',
  iconSize: [30, 50]
});

export const panelIcon = new L.Icon({
  iconUrl: 'assets/images/pins/panel.svg',
  iconSize: [30, 50]
});
